/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Field_Payout_Account_HolderInputs */



/**
* | output |
* | --- |
* | "Payout account holder" |
*
* @param {Partner_Admin_Field_Payout_Account_HolderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_field_payout_account_holder = /** @type {((inputs?: Partner_Admin_Field_Payout_Account_HolderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Field_Payout_Account_HolderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kontoinhaber (Auszahlung)")
	return /** @type {LocalizedString} */ ("Payout account holder")
});